import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconEmail2Plus: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconEmail2Plus"><Path d="M22 4V8.46191L12 13.501L3.5 9.21777V18.5H12V20H2V4H22Z" fill="currentColor"/><Path d="M19.75 13V16.25H23V17.75H19.75V21H18.25V17.75H15V16.25H18.25V13H19.75Z" fill="currentColor"/></CentralIconBase>;
});

export default IconEmail2Plus;
